enum RoutePaths {
    ROOT_PATH = '/',
    JOIN = 'join',
    INFO = 'info',
    PROFILE = 'profile',
    PAYMENT = 'payment',
    PROOF_OF_RIDES = 'proof_of_rides',
    COMPLETE = 'complete',
    UBER_AUTHORIZE = 'uber/authorize',
    UBER_CONNECT_REQUIRED = 'uber-connect-required',
    UBER_LINK = 'uber/link-uber',
    INCOMPLETE_AND_CONTACT_SUPPORT = 'incomplete-and-contact-support',
    LOGIN = 'login',
    TWO_FACTOR_CODE = 'two_factor_code',
    DO_NOT_CONTACT = 'do-not-contact',
    READY_FOR_TABLET = 'ready_for_tablet',
    MAILING_ISSUE = 'mailing_issue',
    MAIL_IN_PROCESS = 'mail_in_process',
    WAITLIST_OTHER = 'waitlist-other',
    WAITLIST = 'waitlist',
    WAITLIST_DEMAND = 'waitlist_demand',
    DASHBOARD_SUMMARY = 'dashboard/summary',
    NOT_INTERESTED = 'not_interested',
    PASSWORD = 'password',
    RESET = 'reset',
    SET_PASSWORD = 'set_password',
    REAPPLY = 'reapply',
    DASHBOARD_MY_ACCOUNT_DRIVER_INFO = 'my-account/driver-info',
    DRIVER_APP_REDIRECT = 'driver-app-redirect',
    LEADERBOARD = 'leaderboard',
    SET_PHONE = 'set-phone',
    ORDER_TRACKING = 'orders/tracking',
}

export const statusRoute: { [key: string]: string } = {
    tos_complete: RoutePaths.INFO,
    driver_info_complete: RoutePaths.PROFILE,
    profile_complete: RoutePaths.PAYMENT,
    payment_complete: RoutePaths.PROOF_OF_RIDES,
    do_not_contact: RoutePaths.DO_NOT_CONTACT,
    interested_ready_for_tablet: RoutePaths.READY_FOR_TABLET,
    interested_mailing_issue: RoutePaths.MAILING_ISSUE,
    interested_mail_in_process: RoutePaths.MAIL_IN_PROCESS,
    interested_dnq_market: RoutePaths.WAITLIST_OTHER,
    interested_dnq_other: RoutePaths.WAITLIST_OTHER,
    interested_dnq_rides: RoutePaths.WAITLIST,
    waitlisted: RoutePaths.WAITLIST_DEMAND,
    former_driver: RoutePaths.DASHBOARD_SUMMARY,
    'Active Driver': RoutePaths.DASHBOARD_SUMMARY,
    interested_mail_delivered: RoutePaths.DASHBOARD_SUMMARY,
    former_driver_mail_delivered: RoutePaths.DASHBOARD_SUMMARY,
    not_interested: RoutePaths.NOT_INTERESTED,
};

export { RoutePaths };
